import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-seller-protection';

export default function Example() {
  return (
    <>
      <Head>
        <title>The Basics of eBay Seller Protection</title>
        <meta
          name='description'
          content='Learn how eBay seller protection works, what constitutes abusive buyers, and the requirements for a seller to qualify for protection.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-seller-protection' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-seller-protection' />
        <meta property='og:title' content='The Basics of eBay Seller Protection' />
        <meta
          property='og:description'
          content='Learn how eBay seller protection works, what constitutes abusive buyers, and the requirements for a seller to qualify for protection.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
